import PageComponent from "components/Page";

import SelectDateRange from "components/SelectDateRange";
import ButtonIconSelect from "components/ButtonIconSelect";
import Select from "components/Select";
import ReportDay from "./reportDay";
import ReportSalary from "./reportSalary";
import ReportLoad from "./reportLoad";

import './index.less';
import './themes/default.less';

export default class Report extends PageComponent {

    constructor(props) {
        super(props);

        const { type, dateFrom, dateTo } = this.state.urlProps;

        const { roleId } = this.state.profile;

        this.state = {
            ...this.state,
            selectedStartDate: dateFrom ? this._helper.date.fromStr(dateFrom) : new Date(),
            selectedEndDate: dateTo ? this._helper.date.fromStr(dateTo) : null,
            currentTypeReport: (type === "salary" || roleId === 4 || roleId === 8) ? 2 : 1,
            currentClinic: 1,
            clinicList: [{ id: 1, name: this.tr("report.allClinics") }]
        };
    }

    componentDidUpdate() {
        const { selectedStartDate, selectedEndDate } = this.state;
        if (this.selectDateRange)
            this.selectDateRange.setInputValue({ selectedStartDate, selectedEndDate, type: selectedEndDate ? 1 : 0 });
    }

    setPageProps({ typeN, dateFromN, dateToN, doctorId, clinic, invoiceId, doctor }) {
        const { type, dateFrom, dateTo } = this._helper.getUrlOptions();
        let props = {};
        props.type = typeN ? typeN : type ? type : "salary";
        if (dateFromN || dateFrom)
            props.dateFrom = dateFromN ? dateFromN : dateFrom;
        else
            props.dateFrom = this.dateToServ(new Date());

        if ((dateToN && props.dateFrom !== dateToN) || (dateTo && props.dateFrom !== dateTo)) {
            props.dateTo = dateToN ? dateToN : dateTo;
        }

        if (doctorId !== undefined)
            props.doctorId = doctorId;

        if (clinic !== undefined)
            props.clinic = clinic;

        if (invoiceId !== undefined)
            props.invoiceId = invoiceId;

        if (doctor !== undefined)
            props.doctor = doctor;

        this._helper.setPageProps(props);
    }

    changeTypeReport(typeReport) {
        this.changeState("currentTypeReport", typeReport);
        if (typeReport === 2) {
            this.setPageProps({ typeN: "salary" });
        } else if (typeReport === 1) {
            this.setPageProps({ typeN: "account" });
        } else {
            this.setPageProps({ typeN: "load" });
            const clinics = this._helper.getClinics();
            console.log("clinics", clinics);

            const clinicList = clinics.map(({ id, fullName }) => ({ id, name: fullName }));
            this.setState({ clinicList });
            console.log("changeTypeReport", clinics);
        }
    }

    getFormatDate() {
        const { selectedStartDate, selectedEndDate } = this.state;

        const dateFrom = this.dateToServ(selectedStartDate);
        const dateTo = this.dateToServ(selectedEndDate || selectedStartDate);

        return { dateFrom, dateTo };
    }

    print(name) {
        const { dateFrom, dateTo } = this.getFormatDate();
        const params = {
            clinicId: this.state.clinicId + "",
        };

        if (name === "Daily_week_report") {
            params.dateFrom = dateFrom;
            params.dateTo = dateTo;
        } else {
            params.date = dateFrom;
        }

        this.printShow(name, { ...params });
    }

    dateToServ(date) {
        return date ? this._helper.date.toDateServerStr(date) : null;
    }

    onForm(selectedRange) {
        const { selectedStartDate, selectedEndDate } = selectedRange;

        const dateFromN = this.dateToServ(selectedStartDate);
        const dateToN = selectedEndDate ? this.dateToServ(selectedEndDate) : null;

        this.setPageProps({ dateFromN, dateToN });
        this.setState({ selectedStartDate, selectedEndDate });
    }

    getClinics() {
        if (this.reportSalary) {
            const { itemsSalary } = this.reportSalary.state;
            const clinicSet = new Set();
            itemsSalary.forEach(it => clinicSet.add(it.clinic));
            const clinics = Array.from(clinicSet);
            clinics.sort();
            clinics.unshift(this.tr("report.allClinics"));
            return clinics.map((name, id) => { return { id: id + 1, name }; });
        }
    }

    setClinics(itemsSalary) {
        const clinicList = [{
            id: 1,
            name: this.tr("report.allClinics")
        }];

        itemsSalary.forEach(it => {
            if (!clinicList.some(clinic => clinic.id === it.clinicId))
                clinicList.push({
                    id: it.clinicId,
                    name: this._helper.getClinicNameById(it.clinicId)
                });
        });

        this.setState({ clinicList });
    }

    downloadXlsx() {
        const { currentTypeReport, selectedStartDate, selectedEndDate, currentClinic, clinicList, profile } = this.state;
        let clinic = false;
        if (currentClinic !== 1)
            clinic = clinicList.find(it => it.id === currentClinic);

        const validity = `${this._helper.date.toStr(selectedStartDate, "DD MMMM YYYY")} - ${this._helper.date.toStr(selectedEndDate, "DD MMMM YYYY")}`;
        if (this.reportSalary && currentTypeReport === 2) {
            const { itemsSalary, itemsSalaryDetails, tableSalaryMode, currentSecondText, itemsSalaryDetailsToplam } = this.reportSalary.state;
            if (tableSalaryMode === "global")
                this._xlsx.reportSalary(itemsSalary, validity, clinic?.id, profile?.id);
            else if (tableSalaryMode === "details")
                this._xlsx.reportSalaryDetails(itemsSalaryDetails, validity, currentSecondText, itemsSalaryDetailsToplam);
        } else if (currentTypeReport === 1) {
            const { info, viewTable } = this.reportDay.state;
            this._xlsx.reportDaily(selectedStartDate, selectedEndDate, info, viewTable);
        }
    }

    renderPage() {
        const { selectedStartDate, selectedEndDate, currentTypeReport, currentClinic, clinicList, profile } = this.state;
        const canSeeReportSalary = this._helper.checkProfilePermissions("reportSalary");
        const canSeeReportDay = this._helper.checkProfilePermissions("reportDay");
        //const canSeeReportLoad = this._helper.checkProfilePermissions("reportLoad");
        const canSeeReportLoad = false;

        const typeReports = [];
        if (canSeeReportDay)
            typeReports.push({ id: 1, name: this.tr("report.dailyReport") },);

        if (canSeeReportSalary)
            typeReports.push({ id: 2, name: this.tr("report.salaryReport") },);

        if (canSeeReportLoad)
            typeReports.push({ id: 3, name: this.tr("Загрузка врачей") },);

        const events = {
            setPageProps: this.setPageProps.bind(this),
            getFormatDate: this.getFormatDate.bind(this),
            setClinics: this.setClinics.bind(this),
        };

        return (
            <div className="flex1 flex col gap16">
                <div className="flex">
                    <div className="flex col gap16">
                        <div className="text pageTitle">{this.tr("report.reports")}</div>
                        <div className="flex gap16 endV">
                            <Select
                                value={currentClinic}
                                label={this.tr("login.clinic")}
                                showLeftIcon={false}
                                items={clinicList}
                                onChange={this.changeState.bind(this, "currentClinic")} />
                            <Select
                                itemStyle="selectType2"
                                value={currentTypeReport}
                                label={this.tr("report.typeReport")}
                                showLeftIcon={false}
                                items={typeReports}
                                onChange={this.changeTypeReport.bind(this)} />
                            <SelectDateRange ref={el => this.selectDateRange = el} onForm={this.onForm.bind(this)} />
                            <ButtonIconSelect
                                translate={true}
                                items={[
                                    { name: "expenses.downloadReportXLS", onClick: this.downloadXlsx.bind(this) },
                                    { name: "expenses.print", onClick: this.print.bind(this, selectedEndDate ? "Daily_week_report" : "Daily_report") },
                                    { name: "client.visits", onClick: this.print.bind(this, "Daily_visits") },
                                ]}
                            />
                        </div>
                    </div>
                </div>
                {(canSeeReportDay && currentTypeReport === 1) ? <ReportDay
                    ref={el => this.reportDay = el}
                    info={this.state}
                    selectedStartDate={selectedStartDate}
                    selectedEndDate={selectedEndDate}
                    events={events}
                /> : currentTypeReport === 2 ?
                    <ReportSalary
                        ref={el => this.reportSalary = el}
                        info={this.state}
                        selectedStartDate={selectedStartDate}
                        selectedEndDate={selectedEndDate}
                        currentClinic={currentClinic}
                        clinicList={clinicList}
                        events={events}
                        profile={profile}
                    /> : <ReportLoad
                        ref={el => this.reportLoad = el}
                        info={this.state}
                        selectedStartDate={selectedStartDate}
                        selectedEndDate={selectedEndDate}
                        currentClinic={currentClinic}
                        clinicList={clinicList}
                        events={events}
                        profile={profile}
                    />}
            </div>
        );
    }
}
